/** Emoji icons for Jyotish topic cards (keys = tab ids). */
import { RASHI_DEEP_DIVE_ICONS } from './jyotishaRashiDeepDiveSearchIndex';
import { GRAHA_GUIDE_ICONS } from './jyotishaGrahaGuideSearchIndex';

export const JYOTISHA_TOPIC_ICONS = {
  'intro-astrology-branches': '🌌',
  'intro-astrology-building-blocks': '🧩',
  'my-readings-western-vedic': '🌗',
  'intro-kundali-types': '📜',
  'intro-varga-calculation': '🧮',
  'intro-chart-fixed-rules': '📐',
  'intro-yoga': '🌟',
  'intro-hora': '🌅',
  nakshatras: '✨',
  'nakshatra-abhijit': '👑',
  'nakshatra-yogatara': '⭐',
  'intro-gandmool': '🧿',
  'nakshatra-profiles': '🌠',
  'intro-nakshatra-dasha-guide': '📿',
  'intro-dasha': '⏳',
  'prarambh-ashtakavarga': '📊',
  'ashtakavarga-six-levels': '🪜',
  'intro-nakshatra-swami-mahadasha-years': '🗂️',
  'intro-nakshatra-udu-dasha-distinction': '💡',
  'rashis-janma-intro': '🌙',
  'rashis-basics': '🌐',
  ...RASHI_DEEP_DIVE_ICONS,
  'rashis-char-sthir-dwiswabhav': '↔️',
  'mool-trikon-rashi': '🔺',
  'houses-bhava': '🏠',
  'bhava-body-parts': '🩺',
  'bhava-dosha': '⚠️',
  'bhava-karma': '♾',
  'bhava-types': '🏛️',
  'bhava-bhavat-bhavam': '🔁',
  'bhava-trees': '🌳',
  'bhava-graha-in-houses': '🪐',
  'bhava-lords-in-houses': '🔑',
  'planets-about-grahas': '🪐',
  ...GRAHA_GUIDE_ICONS,
  'planets-info': '📋',
  'planet-ucch-neech': '🌟',
  'calc-ucch-neech': '⬆️',
  'calc-graha-combustion': '🔥',
  'calc-drishti': '👁️',
  'calc-yog-check': '🌟',
  'calc-dasha-basics': '⏳',
  'calc-house-lord-placement': '🏠',
  'calc-manglik': '🔥',
  'calc-navtara': '✨',
  'calc-tara-bala-daily': '⭐',
  'calc-gandmool': '🪷',
  'calc-panchadha-maitri': '🤝',
  'calc-grah-yuddha': '⚔️',
  'calc-kaal-sarp-type': '🐍',
  'calc-pitru-dosha': '🕯️',
  'calc-gulika': '☽',
  'calc-kemadruma-shakata': '🌑',
  'calc-digbala': '🧭',
  'calc-navamsa-lagna': '9️⃣',
  'calc-ashtakavarga-bindu': '📊',
  'calc-neecha-bhanga': '↗️',
  'calc-varshaphal-lord': '📅',
  'calc-tithi-vara-dosha': '📆',
  'calc-gochar-saturn-jupiter': '♄',
  'planet-sign-transit': '⏱️',
  'planet-margi-vakri': '↩️',
  'planet-digbala': '🌟',
  'planet-shadbala': '📊',
  'planet-deeptadi': '👑',
  'planet-natural-friendship': '🤝',
  'planet-friendship-compound': '🤝',
  'planet-grah-yuddha': '⚔️',
  'planet-avastha': '🔄',
  'planet-drishti': '👁️',
  'planet-gems': '💎',
  'planet-beej-mantras': '🕉️',
  'planet-deities': '🛕',
  'planet-avatars': '🛡️',
  'planet-tatva': '🔥',
  'planet-grains': '🌾',
  'planets-body': '🫀',
  'planets-tissues': '🩸',
  'planet-plants': '🌿',
  'panchang-basics': '🌕',
  'panchang-vara': '📅',
  'panchang-tithi': '🌙',
  'panchang-nakshatra': '⭐',
  'panchang-yoga': '☀️',
  'panchang-karana': '⏳',
  'panchang-27-yogas': '🌟',
  'panchang-bhadra-vishti': '📜',
  'panchang-muhurat': '🕰️',
  'panchang-doshas': '🚫',
  'panchang-festivals': '🛕',
  'panchang-moon-transit': '🌌',
  'panchang-advanced': '🔥',
  'panchang-texts': '📖',
  'prashna-kundali': '❓',
  'phaladeepika-ch1': '📜',
  'charts-d1-vargas-overview': '📇',
  'reading-charts-navamsa-91-labha': '💹',
  'charts-lagna-basic': '📊',
  'my-readings-arudha-lagna': '🔮',
  'reading-charts-bhava-grades': '🏷️',
  'reading-charts-power-of-trikonas': '🔺',
  'reading-charts-gochar-basics': '🪐',
  'reading-charts-vimshottari-ashtottari-dashas': '⚖️',
  'reading-charts-ashtakavarga': '📊',
  'quiz-daily': '✅',
  'quiz-practice': '📋',
  'quiz-results': '📈',
  'reading-charts-planet-12-houses': '🧾',
  'reading-charts-foreign-travel-yoga': '🌍',
  'reading-charts-tithi-dosha': '🗓️',
  'reading-charts-grahan-dosha': '🌘',
  'reading-charts-sun-major-doshas': '☀️',
  'reading-charts-moon-major-doshas': '🌙',
  'reading-charts-mars-major-doshas': '🔥',
  'reading-charts-jupiter-major-doshas': '♃',
  'reading-charts-venus-major-doshas': '✨',
  'reading-charts-saturn-major-doshas': '♄',
  'reading-charts-ketu-major-doshas': '☄️',
  'reading-charts-rahu-major-doshas': '🐉',
  'reading-charts-kala-sarpa-yoga': '🐍',
  'reading-charts-kaal-sarp-12-types': '🐉',
  'reading-charts-vish-yoga': '⚗️',
  'reading-charts-kemadruma-yoga': '🌙',
  'reading-charts-shakata-yoga': '🎡',
  'reading-charts-pitru-dosha': '🕯️',
  'reading-charts-uday-asta': '🌅',
  'reading-charts-graha-combustion': '🔥',
  'reading-charts-panchadha-maitri': '🤝',
  'reading-charts-tatva-combined': '🔥',
  'reading-charts-navtara-chakra': '🌟',
  'reading-charts-nakshatra-charan-naming': '🍼',
  'reading-charts-lagna-mahadasha': '🧭',
  'lagna-baseline-mesha': '🧭',
  'lagna-baseline-vrishabha': '🧭',
  'lagna-baseline-mithuna': '🧭',
  'lagna-baseline-karka': '🧭',
  'lagna-baseline-simha': '🧭',
  'lagna-baseline-kanya': '🧭',
  'lagna-baseline-tula': '🧭',
  'lagna-baseline-vrishchika': '🧭',
  'lagna-baseline-dhanu': '🧭',
  'lagna-baseline-makara': '🧭',
  'lagna-baseline-kumbha': '🧭',
  'lagna-baseline-meena': '🧭',
  'reading-charts-sade-sati-calculator': '🪐',
  'my-readings-loans-emi-chart': '🏦',
  'my-readings-nakshatra-remedy': '🧵',
  'my-readings-graha-friendly-bhavas': '🏠',
  'my-readings-21-life-havans': '🔥',
  'my-readings-child-mantras': '🧒',
  'my-readings-habits-graha': '🪞',
  'my-readings-lal-kitab-21': '📕',
  'my-readings-navagraha-sutras': '📒',
  'my-readings-moon-silent-goals': '🌙',
  'my-readings-brihat-jataka-secrets': '📜',
  'my-readings-rahu-nakshatra': '☊',
  'my-readings-ketu-conjunctions': '☋',
  'my-readings-sun-conjunctions': '☀️',
  'my-readings-moon-conjunctions': '🌙',
  'my-readings-mars-conjunctions': '♂',
  'my-readings-mercury-conjunctions': '☿',
  'my-readings-jupiter-conjunctions': '♃',
  'my-readings-venus-conjunctions': '♀',
  'my-readings-saturn-conjunctions': '♄',
  'my-readings-rahu-conjunctions': '☊',
  'my-readings-eighth-lord-sign': '8️⃣',
  'my-readings-jupiter-lesser-rules': '♃',
  'my-readings-kendradhipati-doshas': '⚠️',
  'my-readings-paap-graha-sthana': '⛓️',
  'my-readings-daily-life-mantras': '🌅',
  'my-readings-rahu-seven-signs': '☊',
  'my-readings-surya-siddhanta-mahayuga': '☉',
  'my-readings-kalapurusha-body-map': '🧍',
  'my-readings-karaka-from-reference': '🔭',
  'jyotisha-stories-chaya-putra': '🌑',
  'jyotisha-stories-brihaspati-karka-uccha': '♋',
  'rituals-navagraha-path': '📿',
  'rituals-daily-graha-remedies': '✨',
  'rituals-sun-remedies-house': '☉',
  'rituals-moon-remedies-house': '☽',
  'rituals-mars-remedies-house': '🔥',
  'rituals-mercury-remedies-house': '☿',
  'rituals-jupiter-remedies-house': '♃',
  'rituals-venus-remedies-house': '✨',
  'rituals-saturn-remedies-house': '♄',
  'rituals-rahu-remedies-house': '☊',
  'rituals-ketu-remedies-house': '☋',
  'rituals-shani-saturday': '🪔',
};
